import Point = PIXI.Point;
import { SceneManager } from '../managers/SceneManager';

export function getPositions(numberOfStacks: number): Point[] {
    const result: Point[] = [];
    const interval: number = SceneManager.gameWidth / (numberOfStacks + 1);
    for (let i: number = 0; i < numberOfStacks; i++) {
        let deltaY: number = 0;
        if (i % 2 === 0) {
            deltaY = -5;
        }
        const point: Point = new Point(interval * (i + 1), 470 + deltaY);
        result.push(point);
    }
    return result;
}